import { useCurrentClientIfAvailable } from 'src/clients/context/CurrentClientProvider';
import { useClients } from 'src/clients/hooks/useClients';
import { ScenarioScope } from '../scope';

/** First names by client id, for everyone whose models a client or family page lists. */
export function useMemberFirstNames(scope: ScenarioScope): Record<string, string> {
  const { client } = useCurrentClientIfAvailable();
  const familyId = scope.kind === 'family' ? scope.id : client?.familyId;
  const { clients } = useClients(familyId ? { familyId } : {}, { enabled: Boolean(familyId) });
  const names: Record<string, string> = Object.fromEntries(
    clients.map(member => [member.id, member.firstName]),
  );
  if (client) {
    names[client.id] = client.firstName;
  }
  return names;
}
